import { render, staticRenderFns } from "./result-details.vue?vue&type=template&id=29ecb2f6&scoped=true&"
import script from "./result-details.vue?vue&type=script&lang=js&"
export * from "./result-details.vue?vue&type=script&lang=js&"
import style0 from "./result-details.vue?vue&type=style&index=0&id=29ecb2f6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ecb2f6",
  null
  
)

export default component.exports